import type { SVGProps } from 'react';

const SvgBroom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M4.01 9.005a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12.61-3.73a.996.996 0 0 0-1.41.04l-5.95 6.27c-.07-.04-.12-.1-.19-.14-1.85-1.07-3.5 0-4.82.86l-.45.29c-1.16.73-3.12.86-3.77.84-.31 0-.59.12-.79.36-.19.23-.27.54-.22.84 1.32 6.76 7.27 8.27 7.52 8.33.08.02.16.03.23.03.33 0 .65-.17.84-.46 1.65-2.56 2.8-5.14 2.98-5.55.52-.94.66-2.02.38-3.06-.08-.31-.21-.6-.36-.88l6.04-6.37c.38-.4.36-1.03-.04-1.41zm-7.79 10.77s-.04.07-.05.11c-.01.02-.99 2.28-2.43 4.65-.46-.18-1.1-.49-1.79-.98.97-.88 1.44-1.63 1.46-1.67.28-.47.13-1.08-.34-1.37-.47-.28-1.08-.13-1.37.33 0 0-.4.65-1.26 1.37a8.5 8.5 0 0 1-1.77-3.11c1.03-.11 2.47-.38 3.59-1.09l.47-.31c1.37-.9 2-1.22 2.72-.81.49.28.83.73.98 1.27s.07 1.11-.21 1.59z"
    />
  </svg>
);
export default SvgBroom;
